import { render, staticRenderFns } from "./receivable.vue?vue&type=template&id=50309fc2"
import script from "./receivable.js?vue&type=script&lang=js&external"
export * from "./receivable.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports